import { Components, Theme } from "@mui/material";

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  defaultProps: {
    size: "small",
    variant: "outlined",
    fullWidth: true,
    autoComplete: "new-password",
    slotProps: {
      htmlInput: {
        autoComplete: "new-password",
        "aria-autocomplete": "none",
      },
    },
  },
};
